import { useEffect, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { setApplicationState } from '../actions/application/application';
import postPusherOrderRowSelect from '../thunks/general/pusher/postPusherOrderRowSelect';
import { usePusher } from '../providers/PusherProvider';
import getPusherOrderRowSelect from '../thunks/general/pusher/getPusherOrderRowSelect';
import getCoOrders from '../thunks/coilovers/orders/getCoOrders';

const normalizeSelectedRows = (rows) => (Array.isArray(rows) ? rows : []);

const PusherOrderListener = () => {
  const dispatch = useDispatch();
  const { pusher: pusherClient, pusherReady } = usePusher();
  const orderRefreshTimerRef = useRef(null);
  const {
    application: {
      otherUserSelectedRow = [],
    },
    me
  } = useSelector((state) => ({
    application: state?.application,
    me: state?.getMyProfile?.user,
  }), shallowEqual);

  useEffect(() => {
    if (!pusherReady || !pusherClient) return;

    const chanelOrder = pusherClient?.subscribe?.('private-co-orders');

    chanelOrder?.bind('client-co-order-select-row', ({ rowsSelected }) => {
      dispatch(setApplicationState({
        otherUserSelectedRow: normalizeSelectedRows(rowsSelected),
      }));
    });

    const refreshOrders = () => {
      if (orderRefreshTimerRef.current) return;

      orderRefreshTimerRef.current = setTimeout(() => {
        orderRefreshTimerRef.current = null;
        dispatch(getCoOrders());
      }, 1000);
    };

    chanelOrder?.bind('co-order-updated', refreshOrders);

    dispatch(getPusherOrderRowSelect()).unwrap().then((d) => dispatch(setApplicationState({
      otherUserSelectedRow: normalizeSelectedRows(d),
    })));

    const otherUserSelectedRowTestUns = [
      ...normalizeSelectedRows(otherUserSelectedRow).filter(({ user }) => user?.id !== me?.id),
    ];

    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(orderRefreshTimerRef.current);
      orderRefreshTimerRef.current = null;
      dispatch(postPusherOrderRowSelect(otherUserSelectedRowTestUns));
      chanelOrder?.unbind('co-order-updated', refreshOrders);
      chanelOrder?.unbind('client-co-order-select-row');
      chanelOrder?.unsubscribe();
    };
  }, [pusherReady, pusherClient]);

  return null;
};

export default PusherOrderListener;
